const enum status {
    MENU,
    DIFFICULTY,
    GAME,
    SCOREBOARD,
    SETTINGS,
}

export default status;